import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { RemovePlansScope } from './removePlansScope';
import styles from './RemoveTreatmentPlansModal.module.css';

// Phrase per scope. The anchor week is interpolated rather than concatenated so
// the translator owns the whole label, including where the week sits in it.
const SCOPE_LABEL_KEYS: Record<RemovePlansScope, string> = {
  plan: 'remove-plans-this',
  onwards: 'remove-plans-onwards',
  row: 'remove-plans-row'
};

const SCOPE_ORDER: RemovePlansScope[] = ['plan', 'onwards', 'row'];

interface RemovePlansScopePickerProps {
  scope: RemovePlansScope;
  /** Start week of the selected plan. Anchors the "from week N" wording. */
  selectedStartWeek: number;
  onChange: (scope: RemovePlansScope) => void;
}

export const RemovePlansScopePicker = ({
  scope,
  selectedStartWeek,
  onChange
}: RemovePlansScopePickerProps) => {
  const { t } = useTranslation();
  const radioGroupName = useId();

  // Native radios rather than the library's RadioButton: it takes no name, so
  // its radios never form one group and arrow keys do not move between them.
  // AffectedGroupsPicker made the same call for the same reason.
  return (
    <fieldset className={styles.picker}>
      <legend className={styles.pickerLabel}>{t('affected-groups-apply-to')}</legend>
      <div className={styles.options}>
        {SCOPE_ORDER.map((value) => (
          <label key={value} className={styles.option}>
            <input
              type="radio"
              name={radioGroupName}
              value={value}
              checked={scope === value}
              onChange={() => onChange(value)}
              className={styles.radio}
            />
            <span className={styles.optionLabel}>
              {t(SCOPE_LABEL_KEYS[value], { week: selectedStartWeek })}
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};
